import VueCookies from 'vue-cookies';
import request from '@/helpers/request';

export default {
  actions: {
    checkCustomerGroupExpiration({ dispatch }) {
      // eslint-disable-next-line
      const ssoSet = VueCookies.get('GARMIN-SSO') == 1;
      const GroupExpNotDismissed = VueCookies.get('GarminGroupExpiredDismissed') === null;

      if (ssoSet && GroupExpNotDismissed) dispatch('callCustomerGroupExpiration');
    },
    async callCustomerGroupExpiration({ dispatch, getters }) {
      const url = getters.getCustomerGroupJsonUrl;
      const msgText = getters.getReactivateCustomerGroup;
      const onClose = () => dispatch('closeCustomeGroupMessage');
      const flashMessage = ['warning', msgText, onClose];
      const config = {
        url,
        credentials: 'include',
        cors: true,
      };
      const showMessage = await request(config).catch(() => {
        throw new Error('Unable to call customerGroupJsonUrl');
      });

      if (showMessage) dispatch('setFlashMessage', flashMessage);
    },
    closeCustomeGroupMessage() {
      VueCookies.set('GarminGroupExpiredDismissed', 'true', { path: '/', domain: '.garmin.com' });

      // eslint-disable-next-line no-underscore-dangle
      if (typeof window._ga_universal !== 'undefined') {
        // eslint-disable-next-line no-underscore-dangle
        window._ga_universal.push(['track_event', 'Customer Group Expiration Message', 'close']);
      }
    },
  },
};
